import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useEffect, useState, useContext } from 'react';
import { ADJUST_EVENTS, EVENTS, sendEvent } from '../../../utils/analytics';
import { useLocalStorageState } from '../../../utils/hooks';
import AdjustContext from '../../../utils/adjustContext';

type Props = {
  className?: string;
  imageHeight?: string;
  creative: string;
  campaign?: string;
};

const BadgeImg = styled.img<{ height: string }>`
  ${({ height }) => height && `height: ${height};`}
  display: inline-block;
  width: 155px;
`;

const PlayStoreBadge = ({
  className,
  imageHeight = '60px',
  creative,
  campaign = 'default',
}: Props) => {
  const [utmTags] =
    useLocalStorageState<{ utm_campaign?: string; utm_source?: string }>('latest-utm-tags');
  const [utmCampaign, setUtmCampaign] = useState<string>(campaign);
  const [utmSource, setUtmSource] = useState<string>('default');
  const adjust = useContext(AdjustContext);

  useEffect(() => {
    if (utmTags?.utm_campaign) {
      setUtmCampaign(utmTags.utm_campaign);
    }
    if (utmTags?.utm_source) {
      setUtmSource(utmTags.utm_source);
    }
  }, [utmTags]);

  const goToMarket = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    adjust?.trackEvent({
      eventToken: ADJUST_EVENTS.clickAppDownload.token,
    });

    sendEvent(EVENTS.clickAppDownload.name, {
      creative,
      campaign,
      'store name': 'play store',
    });
    const target = event.currentTarget;
    const location = target.getAttribute('href');
    if (location) {
      window.location.href = location;
    }
  };

  return (
    <a
      onClick={(e) => goToMarket(e)}
      css={css`
        cursor: pointer;
      `}
      rel="preconnect"
      className={className}
      aria-label="Download on the Play market."
      href={`https://app.adjust.com/hfd6e8n?campaign=${encodeURIComponent(
        utmCampaign,
      )}&adgroup=${encodeURIComponent(utmSource)}&creative=${encodeURIComponent(
        creative,
      )}&engagement_type=fallback_click&fallback=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.milkywire.voyager`}
    >
      <BadgeImg
        loading="lazy"
        height={imageHeight}
        alt="Get it on Google Play."
        src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
      />
    </a>
  );
};
export default PlayStoreBadge;
